import React from 'react';

const MetamaskIcon = () => {
  return (
    <svg
      className="c-MetamaskIcon"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#E2761B"
        stroke="#E2761B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M18.918 4.54l-5.996 4.454 1.109-2.628 4.887-1.826z"
      ></path>
      <path
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M5.074 4.54l5.948 4.496-1.054-2.67L5.074 4.54zM16.76 14.863l-1.598 2.447 3.417.94.982-3.332-2.802-.055zM4.441 14.918l.977 3.332 3.417-.94-1.597-2.447-2.797.055z"
      ></path>
      <path
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M8.642 10.729l-.953 1.44 3.393.15-.12-3.645-2.32 2.055zM15.35 10.729L13 8.632l-.078 3.688 3.387-.15-.959-1.441zM8.834 17.31l2.037-.995-1.76-1.374-.277 2.369zM13.12 16.315l2.042.995-.283-2.369-1.76 1.374z"
      ></path>
      <path
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M15.164 17.31l-2.043-.995.163 1.332-.018.56 1.898-.897zM8.836 17.31l1.898.898-.012-.56.15-1.333-2.036.995z"
      ></path>
      <path
        fill="#233447"
        stroke="#233447"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M10.766 14.061l-1.7-.5 1.2-.548.5 1.048zM13.229 14.061l.5-1.048 1.205.548-1.705.5z"
      ></path>
      <path
        fill="#CD6116"
        stroke="#CD6116"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M8.835 17.309l.29-2.447-1.887.054 1.597 2.393zM14.873 14.862l.29 2.447 1.596-2.393-1.886-.054zM16.307 12.169l-3.387.15.313 1.742.5-1.048 1.206.548 1.368-1.392zM9.065 13.561l1.206-.548.494 1.048.32-1.741-3.394-.151 1.374 1.392z"
      ></path>
      <path
        fill="#E4751F"
        stroke="#E4751F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M7.691 12.169l1.423 2.772-.049-1.38-1.374-1.392zM14.941 13.561l-.06 1.38 1.428-2.772-1.368 1.392zM11.085 12.32l-.32 1.741.398 2.055.09-2.706-.168-1.09zM12.922 12.32l-.162 1.084.072 2.712.404-2.055-.314-1.742z"
      ></path>
      <path
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M13.236 14.062l-.404 2.055.29.199 1.759-1.374.06-1.38-1.705.5zM9.066 13.562l.049 1.38 1.76 1.374.289-.2-.398-2.054-1.7-.5z"
      ></path>
      <path
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M13.265 18.207l.018-.56-.15-.132H10.86l-.139.132.012.56-1.898-.897.663.542 1.344.934h2.308l1.35-.934.663-.542-1.899.898z"
      ></path>
      <path
        fill="#161616"
        stroke="#161616"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M13.121 16.315l-.29-.199h-1.668l-.29.2-.15 1.33.138-.132h2.272l.15.133-.162-1.332z"
      ></path>
      <path
        fill="#763D16"
        stroke="#763D16"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M19.172 9.283l.512-2.459-.765-2.284-5.798 4.303 2.23 1.886 3.152.922.699-.813-.302-.217.483-.44-.374-.29.482-.367-.32-.241zM4.316 6.824l.513 2.459-.326.24.482.368-.367.29.482.44-.301.217.693.813 3.151-.922 2.23-1.886L5.076 4.54l-.76 2.284z"
      ></path>
      <path
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.045"
        d="M18.503 11.65l-3.152-.921.958 1.44-1.428 2.772 1.88-.024h2.802l-1.06-3.267zM8.644 10.729l-3.152.921-1.049 3.267H7.24l1.874.024-1.422-2.772.952-1.44zM12.922 12.32l.198-3.477.917-2.477H9.969l.904 2.477.21 3.477.073 1.097.006 2.7h1.67l.011-2.7.079-1.097z"
      ></path>
    </svg>
  );
};

export default MetamaskIcon;
